import 'core-js/es'
import 'mutation-observer'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

import createRoutes from '@/routes';
import './styles/system/system.less';
import 'moment/locale/zh-cn';
import * as serviceWorker from './serviceWorker';
import { appDevModels } from './models'
import login from './models/login'
import systemMenu from './models/systemMenu'
//import upload from './models/upload'
import { app_storage_key, app_sys_log_key, app_user_log_key, env_host } from './constants/constants_env'

import { component_tool, utils_tool, framework_tool } from './tool'
import file from 'wiz-utils/src/file';
const { WizNotice } = component_tool;
const { Storage } = utils_tool;
const { init, WizTableList, WizReduxTemplate } = framework_tool;
import { WizTableListNew } from './components'
let filePathHeader = env_host && env_host !== '' ? env_host : window.location.origin + '/link';
Storage.setKey(app_storage_key);
//Storage._removeStorage();
const app = init({
  storageKey: app_storage_key,
  createRoutes,
  models: [login, systemMenu],
  appDevModels: appDevModels(),
  initLocalSetting: {
    env: require('./constants/constants_env'),
    files: require('./constants/constants_file'),
    urls: require('./constants/constants_url')
  },
  initGlobal: {
    wizNotice: WizNotice,
    storage: Storage,
    checkEmpty: (d) => {
      if (d && (d !== 0 && d !== '')) {
        return true;
      }
      return false
    },
    getOssFilePath: (fileId) => { return filePathHeader + '/link-server/' + fileId },
    getOssFilePathWatermark: (fileId) => {
      return `${filePathHeader}/link-server/${fileId}?process=image/resize,p_100,q_90/watermark,image_${Base64.encodeURI('image/watermark18.png?x-oss-process=image/resize,P_15')},t_90,g_ne,x_25,y_25`
    },
    getVideoCover:(fileId) => {
      return fileId && fileId !== '' ? `${filePathHeader}/link-server/${fileId}?process=video/snapshot,t_0,f_jpg,m_fast,ar_auto` : undefined
    }
  },
  recodeLog: false,
  recodeLogParams: {
    userLogKey: app_user_log_key,
    sysLogKey: app_sys_log_key,
  },
  templates: { WizTableList, WizReduxTemplate,WizTableListNew }
});

export default app;

// 如果想可以离线使用，请使用register()代替unregister()。可能会带来一些问题，如缓存等
// 相关资料，可以从 https://bit.ly/CRA-PWA 了解
serviceWorker.unregister();
